import React from 'react'
import {connect} from 'react-redux'
import Joyride, { ACTIONS, EVENTS, STATUS } from 'react-joyride';
import {runJoyride} from '../actions/index'
class JoyrideWrapper extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            run : true,
            steps: [
                {
                    target: '.connect',
                    content: 'Connect your DataLooper via USB and hit this icon to connect. After you hit connect, make sure you click "Allow" on the dialog asking to Use Your MIDI Devices ',
                    title: 'Welcome to DataLooper Config',
                    disableBeacon : true
                },
                {
                    target: '.buttonSelector',
                    content: 'Click on a button to see the currently loaded actions.',
                },
                {
                    target: '.actionList',
                    content: 'Click the + icon on actions you want to add to the currently selected button.',
                },
                {
                    target: '.currentButton',
                    content: 'Actions will then show up in this list. Due to memory limitations, we limit each button to 2 actions per preset.',
                },
                {
                    target: '.presetSelector',
                    content: 'You can program additional presets using this preset selector.',
                },
                {
                    target: '.savedocument',
                    content: 'When you\'re all done, save the document by clicking this icon.',
                },
                {
                    target: '.sync',
                    content: 'Then, send the newly created preset to DataLooper by clicking the sync icon',
                },
                {
                    target: '.opendocument',
                    content: 'You can also open previously saved documents',
                },
                {
                    target: '.settings',
                    content: 'If you want to change global settings, click the gear',
                },
                {
                    target: '.panic',
                    content: 'If you ever forget how to use this software, just click the panic button and the walkthrough will start again :) Happy DataLooping!',
                },
            ],
            stepIndex: 0 // a controlled tour
        };

    }

    handleJoyrideCallback = data => {
        const { action, index, status, type } = data;

        if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
            // Update state to advance the tour
            this.setState({ stepIndex: index + (action === ACTIONS.PREV ? -1 : 1) });
        }
        else if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
            // Need to set our running state to false, so we can restart if we click start again.
            this.setState({ stepIndex :0, run: false });
        }

        console.groupCollapsed(type);
        console.log(data); //eslint-disable-line no-console
        console.groupEnd();
    };
    componentDidUpdate(){
        if(this.props.reset){
            this.state.stepIndex = 0;
            this.state.run = true;
        }
    }
    render()
    {
        if(!this.props.cookies.get('firstVisit') || this.props.reset) {
            this.props.cookies.set('firstVisit',true, {path:'/', 'maxAge' : 86400});

            return (<Joyride
            steps={this.state.steps}
            run={this.state.run}
            callback={this.handleJoyrideCallback}
            stepIndex={this.state.stepIndex}
            showSkipButton={true}
            continuous={true}
            showProgress={true}
            />)
        } else{
            return null
        }
        //return (<Joyride
        //    steps={this.state.steps}
        //    run={this.state.run}
        //    callback={this.handleJoyrideCallback}
        //    stepIndex={this.state.stepIndex}
        //    showSkipButton={true}
        //    continuous={true}
        //    showProgress={true}
        //    />)
    }
}


function mapStateToProps(state){
    return{
        reset : state.joyride
    }
}
export default connect(mapStateToProps)(JoyrideWrapper)
